package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.ui.EntityComponent
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.studio.model.ProfileRecord
import ai.flowstorm.studio.resources.space.ProfileRecordResource
import io.kvision.panel.SimplePanel

class ProfileRecordWrapper(val model: ProfileRecordResource) : SimplePanel(), EntityComponent<ProfileRecord> {
    override var entity: ProfileRecord? = null

    private val profileRecordViewer = ProfilerRecordForm()

    override fun load(id: Id): ProfileRecord {
        val profileRecord = model.get(id)
        entity = profileRecord
        return load(profileRecord)
    }

    override fun load(entity: ProfileRecord): ProfileRecord {
        removeAll()
        add(SimplePanel(init = { padding = UiHelpers.spacing }))
        add(profileRecordViewer.load(entity))
        return entity
    }
}